<template>
	<div>
		<v-combobox
		v-model="selected_line"
		:items="line_list"
		item-text="line_name"
		item-value="id"
		:label="$lang.LINE"
		:placeholder="$lang.LINE"
		@focus="getlineList"
		@keydown="getlineList"
		@change="updateLine"
		:search-input.sync="line_serch_query"
		append-icon="mdi-menu-down"
		single-line
		outlined
		clearable
		dense
		:loading="loading"
		:rules="$rules.LINE"
		>
	</v-combobox> 		
</div>
</template>
<script type="text/javascript">

export default {
	data () {
		return {
			loading:false,	
			line_list:[],
			line_serch_query:"",
			selected_line:null
		}
	},
	methods:{
		/* return the selected agent*/ 
		updateLine(){
			this.$emit("update-line",this.selected_line);
		},
		/* fech the line list*/ 
		getlineList(){
			const self=this
			self.loading=true
			let params={
				// warehouse_id:1
			};
			const successHandler = (response) => {
				if (response.data.success){
					self.line_list=response.data.line_list
				}
			};
			const finallyHandler = () => {
				self.loading=false
			};

			self.request_GET( self,self.$urls.LINE_LIST,params,successHandler,null,null,finallyHandler,true)
		},
	}
}
</script>